import React, { FC, useMemo } from 'react';
import { RegistrationFlow } from '../components/RegistrationFlows/RegistrationFlow';
import {
  RegistrationFlowConfiguration,
  hasRequiredRegistrationFlowParams,
  useRegistrationFlowConfiguration,
  RegistrationFlowParams,
} from '../hooks/useRegistrationFlowConfiguration';
import RegistrationCompletion from './RegistrationCompletion';
import { Navigate, useSearchParams } from 'react-router-dom';

const RegistrationFlowView: FC = () => {
  const registrationFlowParams = useRegistrationFlowConfiguration();
  const [searchParams] = useSearchParams();

  const isValidProgressiveRegistration = useMemo(
    () => hasRequiredRegistrationFlowParams(registrationFlowParams),
    [registrationFlowParams]
  );

  // default to MHNL registration component if no flow was specified (legacy flow)
  if (
    searchParams.get(RegistrationFlowParams.REGISTRATION_TYPE) === 'progressive' ||
    searchParams.get(RegistrationFlowParams.REGISTRATION_TYPE) === 'instant'
  ) {
    return isValidProgressiveRegistration ? (
      <RegistrationFlow
        registrationFlowConfig={registrationFlowParams as RegistrationFlowConfiguration}
      />
    ) : (
      <Navigate to={{ pathname: '/error', search: location.search }} replace />
    );
  } else {
    return <RegistrationCompletion />;
  }
};

export default RegistrationFlowView;
